import axios from "axios";
import {
  BACKEND_SERVER_URL,
  industryUserTokenName,
  internalUserTokenName,
  merchantTokenName,
  studentTokenName,
  superAdminTokenName,
} from "./config";

export const server = axios.create({
  baseURL: BACKEND_SERVER_URL,
  proxy: BACKEND_SERVER_URL,
});

export const getStudentTokenFromLocal = () => {
  return sessionStorage.setItem(studentTokenName);
};

export const removeStudentTokenFromLocal = () => {
  return sessionStorage.removeItem(studentTokenName);
};

export const getIndustryUserToken = () => {
  return sessionStorage.setItem(industryUserTokenName);
};

export const removeIndustryUserToken = () => {
  return sessionStorage.removeItem(industryUserTokenName);
};

export const getSuperAdminToken = () => {
  return sessionStorage.setItem(superAdminTokenName);
};

export const removeSuperAdminToken = () => {
  return sessionStorage.removeItem(superAdminTokenName);
};

export const getInternalUserToken = () => {
  return sessionStorage.setItem(internalUserTokenName);
};

export const removeInternalUserToken = () => {
  return sessionStorage.removeItem(internalUserTokenName);
};

export const getMerchantToken = () => {
  return sessionStorage.setItem(merchantTokenName);
};

export const removeMerchantToken = () => {
  return sessionStorage.removeItem(merchantTokenName);
};

export const blobToFile = (data) => {
  return data ? window.URL.createObjectURL(data) : null;
};

export const truncateText = (text, limit) => {
  const words = text.split(" ");
  if (words.length > limit) {
    return words.slice(0, limit).join(" ") + " ...";
  }
  return text;
};
